/**
 * @fileoverview GET handler for the "/api/calculated_attributes/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

// Imported by path, not from the adapters index -- the index does not re-export it.
import { createTableFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createTableFetcherFunctionWithShadowError";
import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { apiCalculatedAttributesAppGroupId } from "./constants";
import type {
  ApiCalculatedAttributesAppGroupIdParams,
  GetApiCalculatedAttributesAppGroupIdResult,
  GetApiCalculatedAttributesAppGroupIdResultErrors,
  GetApiCalculatedAttributesAppGroupIdResultItem,
} from "./types";
import { isGetApiCalculatedAttributesAppGroupIdResult } from "./validators";

export const getApiCalculatedAttributesAppGroupId = reactQueryTableFetcherAdapter(
  apiCalculatedAttributesAppGroupId,
  // The row and result generics are pinned explicitly: `createTableFetcherFunctionWithShadowError`
  // can only infer the row type back out of `TableResult<Result>`, so left to itself it widens the
  // row to `BaseTableResultItem` (`{ id: string }`) and every column accessor stops typechecking.
  createTableFetcherFunctionWithShadowError<GetApiCalculatedAttributesAppGroupIdResultErrors>()<
    ApiCalculatedAttributesAppGroupIdParams,
    GetApiCalculatedAttributesAppGroupIdResultItem,
    GetApiCalculatedAttributesAppGroupIdResult
  >(
    (
      signal: AbortSignal,
      {
        appGroupId,
        query = {},
        groupby,
        limit = 25,
        start = 0,
        sortdir,
        sortby,
      }: ApiCalculatedAttributesAppGroupIdParams
    ): Promise<GetApiCalculatedAttributesAppGroupIdResult> => {
      return fetch(
        `/api/calculated_attributes/${appGroupId}`,
        "GET",
        {
          groupby,
          limit,
          sortby,
          sortdir,
          start,
          query: serializeQueryObjects(query),
        },
        { signal }
      );
    }
  ),
  isGetApiCalculatedAttributesAppGroupIdResult
);
